<template>
    <div>
        <div class="public-profile-wrapper">
            <div class="surface-section min-h-screen ">
                <div>
                    <div class="banner-responsive" :style="bannerStyleObject"></div>
                    <div class="overlap-section col-12  flex justify-content-center align-items-center">
                        <div
                            class="flex flex-column md:flex-row align-items-center justify-content-between w-full mt-3 gap-3">
                            <div class="flex flex-column md:flex-row align-items-center gap-3 text-center md:text-left">
                                <img :src="profileImage" class="profile-image" alt="Profile" />
                                <div class="profile-info">
                                    <h1 class="H5-SemiBold mb-1">{{ profileDetails?.username || 'N/A' }}</h1>
                                    <p class="caption mb-0">{{ profileDetails?.currentInstitution || 'N/A' }}</p>
                                </div>
                            </div>
                            <a :href="profileDetails?.email ? `mailto:${profileDetails.email}?subject=Contact%20Request&body=Hello` : 'mailto:support@ilearndsl.com?subject=Contact%20Request&body=Hello'"
                                target="_blank" rel="noopener">
                                <Button class="accent-button" icon="pi pi-comments" label="Contact Me" />
                            </a>

                        </div>
                    </div>
                </div>
                <div class="flex flex-column col-12  mt-4 justify-content-center align-items-center mx-auto">
                    <div class="card w-full">
                        <Tabs value="0">
                            <TabList>
                                <Tab class="Label" v-for="tab in tabs" :key="tab.title" :value="tab.value">{{
                                    tab.title }}</Tab>
                            </TabList>
                            <TabPanels>
                                <TabPanel v-for="tab in tabs" :key="tab.content" :value="tab.value">
                                    <component :is="tab.component" :profileDetails="profileDetails"
                                        :enrolledTutors="enrolledTutors"
                                        :previousEnrolledTutors="previousEnrolledTutors" />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, shallowRef, defineProps, onMounted } from "vue";
import bannerImg from "@/assets/Images/studentCoverProfile.png";
import Button from 'primevue/button';
import { generateSignedUrl } from '@/api/storage';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import ProfileInfo from "@/components/adminStudentProfile/profileInfo.vue";
import ClassSchedules from "@/components/adminStudentProfile/enrolledTutors.vue";
import TeachingNotices from "@/components/adminStudentProfile/tutorHistory.vue";
import blankProfile from '@/assets/blank-profile.png';

const props = defineProps({
    profileDetails: null,
    enrolledTutors: null,
    previousEnrolledTutors: null
})
const bannerImgRef = ref(bannerImg);
const profileImage = ref(null);
const bannerStyleObject = computed(() => ({
    backgroundImage: `url(${bannerImgRef.value})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
}));

const tabs = ref([
    {
        title: 'Profile info',
        value: '0',
        component: shallowRef(ProfileInfo)
    },
    {
        title: 'Registered tutors',
        value: '1',
        component: shallowRef(ClassSchedules)
    },
    {
        title: 'History(Previous tutors)',
        value: '2',
        component: shallowRef(TeachingNotices)
    },
]);
onMounted(async () => {
    if (props.profileDetails?.profilePhotoURL) {
        try {
            profileImage.value = await generateSignedUrl(props.profileDetails.profilePhotoURL);
        } catch (err) {
            console.error("Failed to generate signed URL:", err);
            profileImage.value = blankProfile;
        }
    } else {
        profileImage.value = blankProfile;
    }
});

</script>

<style scoped>
.banner-responsive {
    height: 500px;
    background-color: transparent;
}

.overlap-section {
    position: relative;
    margin-top: -4rem;
    background: transparent;
    padding: 0 1rem;
    margin-left: auto;
    margin-right: auto;
}

.profile-image {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    border: 4px solid white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    object-fit: contain;
    margin-top: -10px;
}

.profile-info {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
}

.p-tab {
    --p-tabs-tab-active-color: var(--accent-500);
    --p-tabs-tab-hover-color: var(--accent-500);
    --p-tabs-tab-font-weight: 600;
}

@media (max-width: 767px) {
    .overlap-section {
        margin-top: -3rem;
        padding: 0 0.5rem;
    }

    .profile-image {
        width: 120px;
        height: 120px;
        margin-top: -5px;
    }

    .profile-info {
        margin-top: 15px;
    }



    .banner-responsive {
        height: 350px;
        object-fit: contain !important;
    }
}

/* Tablet Styles */
@media (min-width: 768px) and (max-width: 1023px) {
    .overlap-section {
        margin-top: -3.5rem;
    }

    .profile-image {
        width: 140px;
        height: 140px;
    }
}
</style>